import script from "./HomeComponent.vue?vue&type=script&setup=true&lang=tsx"
export * from "./HomeComponent.vue?vue&type=script&setup=true&lang=tsx"

import "./HomeComponent.vue?vue&type=style&index=0&id=fa9b0f44&lang=css"
import "./HomeComponent.vue?vue&type=style&index=1&id=fa9b0f44&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fa9b0f44"]])

export default __exports__